import { useRoutes, Navigate, useParams, useLocation } from 'react-router-dom';
import BUList from "./pages/BUList";
import PlantList from './pages/PlantList';
import FactoryList from "./pages/FactoryList";
import LineList from './pages/LineList';
import LineDetail from './pages/LineDetail';
import ExternalRedirect from "./components/auth/ExternalRedirect";
import MainLayout from './components/layout/MainLayout';
import MainLayoutProductionTracking from './components/layout/MainLayoutProductionTracking';
import PerformanceTab from './pages/PerformanceTab';
import GiveawayTab from './pages/GiveawayTab';
import MarinationTab from './pages/MarinationTab';
import InfeedTab from './pages/InfeedTab';
import AllUser from './pages/account_page/AllUser';
import Register from './pages/account_page/Register';
import WipRegister from './pages/register/Register';
import MobileScan from './pages/mobile_scan/MobileScan';
import WipMasterList from './pages/monitor/WipMasterList';
import InlineMonitor from './pages/monitor/InlineMonitor';
import WipMasterForm from './components/setting/WipMasterForm';
import LowCare from './pages/monitor/LowCare';
import StockTablePage from './components/monitor/StockTablePage';
import WipStock from './pages/monitor/WIP';
import RawMaterialStock from './pages/monitor/RawMeat';
import UserEdit from './components/account/UserEdit';
import Setting from './pages/setting_page/Setting';
import MasterPlantEdit from './components/setting/MasterPlantEdit';
import NewMasterPlant from './pages/setting_page/NewMasterPlant';
import MasterPlantList from './pages/setting_page/MasterPlant';
import MasterSTDPlant from './pages/setting_page/MasterSTDPlant';
import MasterSTDFactory from './pages/setting_page/MasterSTDFactory';
import MasterSTDLisi from './pages/setting_page/MasterSTD';
import NewMasterSTD from './pages/setting_page/NewMasterSTD';
import StandardSettingEdit from './components/setting/StandardSettingEdit';
import CorrelationTab from './pages/CorrelationTab';
import OverviewTab from "./pages/mes_korat_on_web/OverviewTab";
import ProductionLine from './pages/mes_korat_on_web/ProductionLine';
import ProductionEggP1 from './pages/rollout/performance/ProductionEggP1';
import PerformanceDetailFPP1 from './pages/fpp1/PerformanceDetailFPP1Page1';
import HeatingYield from './pages/heating_yield/HeatingYield';
import TumblerTracking from './pages/tumbler_tracking/TumblerTracking';
import TumblerScheduling from './pages/tumbler_tracking/TumblerScheduling';
import TumblerProductMaster from './pages/tumbler_tracking/TumblerProductMaster';
import FGTrackingLine7Line8 from './pages/fg_tracking/FGTrackingLine7Line8';
import FGTrackingLine9Line10 from './pages/fg_tracking/FGTrackingLine9Line10';
import QualityMonitoring from './pages/quality/QualityMonitoring';
import GiveawayRolloutTab from './pages/rollout/giveaway/GiveawayRolloutTab';
import ProductionAirChillLine1 from './pages/slh/ProductionAirChillLine1';
import ProductionAirChillLine2 from './pages/slh/ProductionAirChillLine2';
import ProductionChickenRest from './pages/slh/ProductionChickenRest';
import ProductionChickenTap from './pages/slh/ProductionChickenTab';
import OEEDashboardTab from './pages/nongjok/OEEDashboardTab';
import OEEDashboardKorat from './pages/oeeDashboard/App';
import PerformancePage1 from './pages/rollout/performance/4045/PerformancePage1';

import ProductionOMS from './pages/slh/omspig/ProductionOMS';
import SchedulePlantDowntime from './pages/SchedulePlantDowntime';
import Defect from './pages/Defect';
import DefectV1 from './pages/DefectV1';
import SigmaTrackGiveawayPage1 from './pages/sigma_track/giveaway/v1/page1';
import SigmaTrackGiveawayPage2 from './pages/sigma_track/giveaway/v1/page2';
import SigmaTrackMasterPage    from './pages/sigma_track/giveaway/v1/MasterPage';
import SigmaTrackGiveawayTab   from './pages/sigma_track/giveaway/v1/GiveawayTab';


const LayoutSwitcher = () => {
  const { factory, line, detail } = useParams();

  if (factory === "FPP2" && line === "Line7" && detail === "OEE Dashboard") {
    return <MainLayoutProductionTracking />;
  }
  return <MainLayout />;
};


const OEEDashboardOrDetailTabs = () => {
  const { factory, line, detail } = useParams();

  if (factory === "FPP2" && line === "Line7" && detail === "OEE Dashboard") {
    return <Navigate to="oee" replace />;
  }

  return <DetailTabs />;
};


const DetailTabs = () => {
  const { bu, plant, factory, detail, line } = useParams();

  switch (true) {
    case detail === "Performance":
      return <PerformanceTab />;
    case detail === "Giveaway" && factory === "FPP2":
      return <GiveawayTab />;
    case detail === "Marination Tracking":
      return <MarinationTab />;
    case detail === "MobileInfeed":
      return <InfeedTab />;
    case detail === "Heating Yield":
      return <HeatingYield />;
    case detail === "Unlockgiveaway":
      return <CorrelationTab />;
    case detail === "OverviewDashboard":
      return <OverviewTab />;
    case detail === "Tumbler Tracking":
      return <TumblerTracking />;
    case detail === "FG Tracking" && (line === 'Line7' || line === 'Line8'):
      return <FGTrackingLine7Line8 />;
    case detail === "FG Tracking" && (line === 'Line9' || line === 'Line10'):
      return <FGTrackingLine9Line10 />;
    case detail === "Quality Monitoring":
      return <QualityMonitoring />;
    case detail === "Performance Packing":
      return <PerformanceDetailFPP1 />;
    case detail === "Giveaway Rollout":
      return <GiveawayRolloutTab />;
    case detail === "AirChill" && factory === "SLHKorat" && line === "Line1":
      return <ProductionAirChillLine1 />;
    case detail === "AirChill" && factory === "SLHKorat" && line === "Line2":
      return <ProductionAirChillLine2 />;
    case detail === "Lairage" && factory === "SLHKorat" && line === "Lairage":
      return <ProductionChickenRest />;
    case detail === "LiveChicken" && factory === "SLHKorat":
      return <ProductionChickenTap />;
    case bu === "FOOD AND BEVERAGE" && detail === "OEEDashboard":
      return <OEEDashboardTab />;
    case detail === "Performance" && factory === "00000000000001":
      return <PerformancePage1 />;
    case bu === "PIG SLH" && detail === "CUT UP PROCESSING":
      return <ProductionOMS />;
    case detail === "Schedule Plant Downtime":
      return <SchedulePlantDowntime />;
    case detail === "Defect" && factory === "FPP2":
      return <Defect />;
    case detail === "WIP Tracking":
      return <WipRegister />;
    default:
      return <BUList />;
  }
};

function LegacyWipRedirect() {
  const { bu, plant, factory } = useParams();
  const location = useLocation();
  const suffix = decodeURI(location.pathname).split('/WIP Tracking')[1] || '';
  const base = '/' + [bu, plant, factory, 'WIP Tracking'].map(encodeURIComponent).join('/');
  return <Navigate to={base + suffix + location.search} replace />;
}

const routes = (isLoggedIn) => [
  {
    path: "/",
    element: isLoggedIn ? <MainLayout /> : <ExternalRedirect to="https://www.axonscloud.com/" />,
    children: [
      { path: "/", element: <BUList /> },
      { path: ":bu/", element: <PlantList /> },
      { path: ":bu/:plant", element: <FactoryList /> },
      { path: ":bu/:plant/:factory", element: <LineList /> },
      { path: ":bu/:plant/:factory/Tumbler Scheduling", element: <TumblerScheduling /> },
      { path: ":bu/:plant/:factory/Tumbler Product Master", element: <TumblerProductMaster /> },
      { path: ":bu/:plant/:factory/:line", element: <LineDetail /> },

      { path: "account", element: <AllUser /> },
      { path: "register", element: <Register /> },
      { path: ":bu/:plant/:factory/WIP Tracking/master", element: <WipMasterList /> },
      { path: ":bu/:plant/:factory/WIP Tracking/master/new", element: <WipMasterForm /> },
      { path: ":bu/:plant/:factory/WIP Tracking/master/edit", element: <WipMasterForm edit /> },
      { path: ":bu/:plant/:factory/WIP Tracking", element: <WipRegister /> },
      { path: ":bu/:plant/:factory/WIP Tacking", element: <LegacyWipRedirect /> },
      { path: ":bu/:plant/:factory/:line/WIP Tacking", element: <LegacyWipRedirect /> },
      { path: ":bu/:plant/:factory/WIP Tracking/mobile-scan", element: <MobileScan /> },
      { path: ":bu/:plant/:factory/WIP Tracking/low-care", element: <LowCare /> },
      { path: ":bu/:plant/:factory/WIP Tracking/in-line-monitor", element: <InlineMonitor /> },
      { path: ":bu/:plant/:factory/WIP Tracking/raw-mat", element: <RawMaterialStock /> },
      { path: ":bu/:plant/:factory/WIP Tracking/wip", element: <WipStock /> },
      { path: ":bu/:plant/:factory/WIP Tracking/fg", element: <StockTablePage title="FG" category="FG" /> },
      { path: ":bu/:plant/:factory/:line/WIP Tracking", element: <LegacyWipRedirect /> },
      { path: "wip-tracking/register", element: <WipRegister /> },
      { path: "wip-tracking/mobile-scan", element: <MobileScan /> },
      { path: ":bu/:plant/:factory/:line/WIP Tracking/mobile-scan", element: <LegacyWipRedirect /> },
      { path: "wip-tracking/low-care", element: <LowCare /> },
      { path: "wip-tracking/wip", element: <WipStock /> },
      { path: "wip-tracking/raw-mat", element: <RawMaterialStock /> },
      { path: ":bu/:plant/:factory/:line/WIP Tracking/low-care", element: <LegacyWipRedirect /> },
      { path: ":bu/:plant/:factory/:line/WIP Tracking/wip", element: <LegacyWipRedirect /> },
      { path: ":bu/:plant/:factory/:line/WIP Tracking/raw-mat", element: <LegacyWipRedirect /> },
      { path: "mobile-scan", element: <Navigate to="/wip-tracking/mobile-scan" replace /> },
      { path: "user-edit", element: <UserEdit /> },
      { path: "setting", element: <Setting /> },
      { path: "setting/new-master-plant", element: <NewMasterPlant /> },
      { path: "setting/edit-master-plant", element: <MasterPlantEdit /> },
      { path: "setting/list-master-plant", element: <MasterPlantList /> },
      { path: "setting/master-std-plant", element: <MasterSTDPlant /> },
      { path: "master-std-factory", element: <MasterSTDFactory /> },
      { path: "list-master-std", element: <MasterSTDLisi /> },
      { path: "new-master-std", element: <NewMasterSTD /> },
      { path: "edit-master-std", element: <StandardSettingEdit /> },
      { path: "productionLine", element: <ProductionLine /> },

      // ── Sigma Track — Giveaway ──────────────────────────────────────────
      { path: 'sigma-track/master', element: <SigmaTrackMasterPage /> },
      {
        path: ':bu/:plant/:factory/:line/Sigma Track',
        element: <SigmaTrackGiveawayTab />,
        children: [
          { index: true, element: <Navigate to="1" replace /> },
          { path: '1', element: <SigmaTrackGiveawayPage1 /> },
          { path: '2', element: <SigmaTrackGiveawayPage2 /> },
        ],
      },
    ],
  },

  {
    path: "/:bu/:plant/:factory/:line/:detail",
    element: isLoggedIn ? <LayoutSwitcher /> : <ExternalRedirect to="https://api.axonscloud.com" />,

    children: [
      { index: true, element: <OEEDashboardOrDetailTabs /> },

      {
        path: "oee/*",
        element: <OEEDashboardKorat />,
      },
    ],
  },

  {
    path: "/",
    element: isLoggedIn ? <MainLayoutProductionTracking /> : <ExternalRedirect to="https://api.axonscloud.com" />,
    children: [
      { path: "egg-nj/performance/line3/p1", element: <ProductionEggP1 /> },
    ],
  },
];


function RoutesConfig({ loggedIn }) {
  return useRoutes(routes(loggedIn));
}

export default RoutesConfig;
